import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    selectCompanyField: {
      fontWeight: 500,
      '& .MuiInputBase-input': {
        cursor: 'pointer',
      },
    },
    likeCell: {
      width: 20,
      padding: 0,
      textAlign: 'center',

      '& svg': {
        fontSize: 14,
        fill: palette.primary.main,
      },
    },
    companySelected: {
      '& .MuiTableCell-root': {
        fontWeight: 600,
        lineHeight: 0,
      },
    },
    tableRow: {
      height: 20,
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      '& .MuiTableCell-root': {
        padding: '0 0 0 16px',
        color: palette.gray,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
  });
